export default __webpack_public_path__ + "static/media/edit.92d0be6b.svg";